import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";

export const CoachSchedulerAPI = {
    postCreateSchedule: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/coach-scheduler/create`,
            method: "POST",
            timeout: 5000,
            data:reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateSchedule: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/coach-scheduler/update`,
            method: "PUT",
            timeout: 5000,
            data:reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putUpdateRSVPRequestStatus: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/coach-scheduler/rsvp/status`,
            method: "PUT",
            timeout: 20000,
            data: reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    putConfirmFreeSchedule: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/coach-scheduler/confirm`,
            method: "PUT",
            timeout: 5000,
            data:reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    updateScheduleStatus: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/coach-scheduler/update/status`,
            method: "PUT",
            timeout: 20000,
            data:reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    findPlayerTeamDetails: async function (clubId, userId) {
        const response = await axiosInstance.request({
            url: `/coach-scheduler/player-team/${clubId}/user/${userId}`,
            method: "GET",
            timeout: 5000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    findAllTeamByCoachOrg: async function (orgId, seasonId) {
        const response = await axiosInstance.request({
            url: `/team/org/${orgId}`,
            method: "GET",
            timeout: 5000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    findAllCoachSchedule: async function (reqData) {
        const response = await axiosInstance.request({
            url: `/coach-scheduler/all`,
            method: "POST",
            timeout: 20000,
            data:reqData,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    findAllUserRSVPRequests: async function (userId,clubId) {
        const response = await axiosInstance.request({
            url: `/coach-scheduler/rsvp/${clubId}/user/${userId}`,
            method: "GET",
            timeout: 5000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    findTotalUnPaidSchedule: async function (userId,clubId) {
        const response = await axiosInstance.request({
            url: `/coach-scheduler/total/unpaid/${clubId}/user/${userId}`,
            method: "GET",
            timeout: 5000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
}